'use strict'
import { App } from '../../config/app.js'
import { Modal } from '../../modal.js'
import { getError } from '../../helper.js'

export default function ()
{
	App.Modal.Address = new Modal('Address',
	{
		onOpen: async (modal, data) =>
		{
			if (data.id)
			{
				modal.options.actionSubmitName = 'address update'

				return Promise.all(
					[
						App.Store.fetch('address', data.id, { 'include': '*' }),
						App.Store.fetch('country', 0, { include: 'stateProvince' })
					])
					.then(results =>
					{
						modal.view.model.clear()
						modal.view.model.sync(data)
						modal.view.model.sync(results[0])
					})
			}

			modal.options.actionSubmitName = 'address create'
			return App.Store.fetch('country', 0, { include: 'stateProvince' })
				.then(() =>
				{
					modal.view.model.clear()
					modal.view.model.sync(data)
					modal.view.render()
				})
		},
		onActionAfter: (modal, e) =>
		{
			if (!e.detail.success)
			{
				const error = getError(e)
				if (error.status == 410)
				{
					// An address is gone, refresh grid
					e.preventDefault()
					App.Store.pagingReset('address')
					modal.close()
				}
			}
		}
	})
}
